import './stack.css'
import './web_component'
import React from 'react'
import { StackLayoutProps } from './types'

export const Stack: React.FC<StackLayoutProps> = ({ children, ...props }) => <stack-l {...props}>{children}</stack-l>
